import React from "react";
import AccordionV2 from "@components/Accordion/AccordionV2";
import EventsAwardsAccordionHeader from "@events-awards/EventsAwardsAccordionHeader";
import { EY_URL } from "@util/constant";

/**
 * Component to render EY section on Partners page
 */
const EYSection = (): React.ReactElement => {
  return (
    <div className="bg-gray-150" data-testid="ey-section-component">
      <AccordionV2
        testId="ey"
        className="border-l border-r py-4"
        headerChildren={<EventsAwardsAccordionHeader title="EY" />}
        arrowClassName="h-auto w-auto -rotate-90 mr-6 border-none"
        isArrowRight
      >
        <div className="mt-4 border-t border-gray-175 px-6 py-4 pt-4">
          <p>
            EY exists to build a better working world, helping to create
            long-term value for clients, people and society and build trust in
            the capital markets. Enabled by data and technology, diverse EY
            teams in over 150 countries provide trust through assurance and help
            clients grow, transform and operate. Working across assurance,
            consulting, law, strategy, tax and transactions, EY teams ask better
            questions to find new answers for the complex issues facing our
            world today.
          </p>

          <p>
            For more information, please visit&nbsp;
            <a
              className="text-blue-175 hover:text-gray-750"
              href={EY_URL}
              target="_blank"
              rel="noreferrer"
            >
              ey.com
            </a>
            .
          </p>
        </div>
      </AccordionV2>
    </div>
  );
};

export default EYSection;
